function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'red': 'rgb(239, 0, 3)','orange': 'rgb(242, 97, 0)','yellow': 'rgb(255, 233, 0)','lime-green': 'rgb(35, 239, 20)','apple-green': 'rgb(0, 183, 43)','forest-green': 'rgb(4, 60, 47)','olympic-blue': 'rgb(0, 139, 240)','dark-blue': 'rgb(0, 18, 254)','violet-purple': 'rgb(97, 0, 166)','dark-gray': 'rgb(78, 88, 90)','silver': 'rgb(176, 181, 184)','white': 'rgb(255, 255, 255)','chrome-red': 'rgb(170, 13, 32)','chrome-blue': 'rgb(0, 95, 177)','cyan-blue': 'rgb(0, 153, 211)','silver-white': 'rgb(231, 231, 231)','monochrome': 'rgb(204, 204, 204)',};

    this.images = {'carbon-fiber': 'url("//rebadgedesign.com/cdn/shop/files/Carbon_Fiber_120x.jpg?v=14484303409275488998")','us-flag': 'url("//rebadgedesign.com/cdn/shop/files/US_Flag_Color_Image_120x.jpg?v=1327803661259858342")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
